import React, { useState, useCallback, useEffect } from "react";
import { Col, Row, Card, Form, Input, DatePicker, TreeSelect } from "antd";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { get, includes, map, toLower, size, join, trim } from "lodash";
import { PAGINATION } from "../../_redux/constant";
import { barrierThunks } from "../../_redux/thunk";
import { TIME_FORMAT_DATE_TIME } from "../../../app/_redux/constants";
import AppBaseSelect from "../../../../../core/components/baseSelect";
import { removeVietnameseTones } from "../../../../../lib/admin";
import {
  convertObjToArrObj,
  convertStationGate,
} from "../../../../../lib/util";
import Log from "../../components/log/logiMotoList";
import { RANGE_PICKER_RANGES } from "app/modules/camera/_redux/constants";

let timer = null;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;
const { TreeNode } = TreeSelect;
function BarrierLogPage() {
  const CARD_STYLE = {
    borderRadius: "0.42rem",
    boxShadow: "0px 0px 30px 0px rgba(82, 63, 105, 0.05)",
  };
  const today = new Date();
  const { RangePicker } = DatePicker;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    direction,
    open_type,
    stations,
    station_gates,
    recognize_type,
  } = useSelector((state) => state.barrier.barrierLog.filterData);
  const { data, total_elements } = useSelector(
    (state) => state.barrier.barrierLog.log
  );
  const [params, setParams] = useState({
    size: PAGINATION.log.size,
    page: PAGINATION.log.page,
    type: "MOTO",
    from: dayjs(today)
      .startOf("day")
      .toISOString(),
    to: dayjs(today)
      .endOf("day")
      .toISOString(),
  });

  const _handleChangeParam = useCallback(async ({ gateIds, stationIds }) => {
    let from, to;
    const { license_plate, direction, time } = form.getFieldsValue();

    if (time) {
      from = dayjs(time[0]).toISOString();
      to = dayjs(time[1]).toISOString();
    }
    setParams((prev) => ({
      ...prev,
      from,
      to,
      license_plate: license_plate
        ? license_plate.replace(/[^a-zA-Z0-9]/g, "")
        : undefined,
      direction,
      page: PAGINATION.log.page,
      size: PAGINATION.log.size,
      gate_ids:
        gateIds && size(gateIds) && size(join(gateIds, ","))
          ? join(gateIds, ",")
          : undefined,
      station_ids:
        stationIds && size(stationIds) && size(join(stationIds, ","))
          ? join(stationIds, ",")
          : undefined,
    }));
  }, []);

  const dataSource = map(data, (item, index) => ({
    ...item,
    stt:
      params.page === 0
        ? index + 1
        : (params.page - 1) * params.size + index + 1,
  }));
  const [loading, setLoading] = useState(false);
  const [activeKey, setActiveKey] = useState("all");

  const _handleGetFilterData = useCallback(async () => {
    await dispatch(barrierThunks.getLogFilterDataThunk());
  }, []);
  const _handleGetLogs = useCallback(
    async () => {
      setLoading(true);
      await dispatch(barrierThunks.getLogThunk(params));
      setLoading(false);
    },
    [params]
  );
  const _handleChangeInput = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      clearTimeout(timer);
      _handleChangeFilter();
    }, 800);
  };
  const _handleChangeFilter = () => {
    let from, to;
    const {
      license_plate,
      direction,
      station_id,
      gate_id,
      time,
      open_type,
      recognize_type,
      username,
    } = form.getFieldsValue();

    if (time) {
      from = dayjs(time[0]).toISOString();
      to = dayjs(time[1]).toISOString();
    }
    let searchUsername = trim(username) ? trim(username) : undefined;
    let searchLicense_plate = trim(license_plate)
      ? trim(license_plate.replace(/[^a-zA-Z0-9]/g, ""))
      : undefined;
    setParams((prev) => ({
      ...prev,
      from,
      to,
      station_id,
      gate_id,
      username: searchUsername,
      license_plate: searchLicense_plate,
      direction,
      open_type,
      recognize_types:
        recognize_type &&
        size(recognize_type) &&
        size(join(recognize_type, ","))
          ? join(recognize_type, ",")
          : [],
      page: PAGINATION.log.page,
      size: PAGINATION.log.size,
    }));
  };
  const _handleDisabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };
  const onChangeParam = (param) => {
    if (!param.page && !param.size) {
      param.page = PAGINATION.log.page;
      param.size = PAGINATION.log.size;
    }
    setParams((prev) => ({ ...prev, ...param }));
  };

  useEffect(
    () => {
      _handleGetFilterData();
      _handleGetLogs();
    },
    [_handleGetFilterData, _handleGetLogs]
  );

  return (
    <Row className="barrier-log__page" gutter={[8, 8]}>
      <Col span={24}>
        <Card
          bodyStyle={{ paddingBottom: "0" }}
          size="small"
          style={CARD_STYLE}
        >
          <Row align="middle" justify="space-between" span={24}>
            <Form
              form={form}
              layout={"vertical"}
              style={{ width: "100%" }}
              initialValues={{
                time: [
                  dayjs("00:00:00", "HH:mm:ss"),
                  dayjs("23:59:59", "HH:mm:ss"),
                ],
              }}
            >
              <Row gutter={[16, 0]}>
                <Col className="gutter-row" span={5}>
                  <Form.Item label={"Thời gian"} name={"time"}>
                    <RangePicker
                      disabledDate={_handleDisabledDate}
                      showTime
                      presets={RANGE_PICKER_RANGES}
                      format={TIME_FORMAT_DATE_TIME}
                      onChange={_handleChangeFilter}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={3}>
                  <Form.Item
                    colon={false}
                    label="Kho"
                    labelAlign="left"
                    labelCol={{ span: 3 }}
                  >
                    <TreeSelect
                      disabled={activeKey !== "all"}
                      multiple
                      dropdownStyle={{
                        maxHeight: 400,
                        overflow: "auto",
                        overflowX: "hidden",
                      }}
                      filterTreeNode={(input, treeNode) => {
                        return includes(
                          toLower(
                            removeVietnameseTones(get(treeNode, "title"))
                          ),
                          toLower(removeVietnameseTones(input))
                        );
                      }}
                      placeholder="Chọn kho"
                      showCheckedStrategy={SHOW_PARENT}
                      style={{ width: "100%" }}
                      treeCheckable={true}
                      onChange={(data) => {
                        _handleChangeParam(convertStationGate(data, stations));
                      }}
                    >
                      {map(station_gates, (station) => {
                        return (
                          <TreeNode
                            key={station.station_name}
                            selectable={false}
                            title={station.station_name}
                            value={station.station_name}
                          >
                            {map(station.gates, (gate) => {
                              return (
                                <TreeNode
                                  key={gate.gate_id}
                                  selectable={false}
                                  title={gate.gate_name}
                                  value={gate.gate_id}
                                />
                              );
                            })}
                          </TreeNode>
                        );
                      })}
                    </TreeSelect>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={3}>
                  <Form.Item label="Kiểu mở" name="open_type">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Kiểu mở"
                      dataSource={convertObjToArrObj(open_type)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item label="Phân loại" name="recognize_type">
                    <AppBaseSelect
                      allowClear
                      mode={"multiple"}
                      allowConvert={true}
                      placeholder="Phân loại"
                      dataSource={convertObjToArrObj(recognize_type)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col>
                {/* <Col className="gutter-row" span={3}>
                  <Form.Item label="Hướng cổng" name="direction">
                    <AppBaseSelect
                      allowConvert={true}
                      placeholder="Loại xác minh"
                      dataSource={convertObjToArrObj(direction)}
                      valueKey="key"
                      labelKey="value"
                      onChange={_handleChangeFilter}
                    />
                  </Form.Item>
                </Col> */}
                <Col className="gutter-row" span={4}>
                  <Form.Item label="Biển số" name="license_plate">
                    <Input
                      allowClear
                      placeholder={"Biển số"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item label="Username" name="username">
                    <Input
                      allowClear
                      placeholder={"Username"}
                      onChange={_handleChangeInput}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Row>
        </Card>
      </Col>
      <Col span={24}>
        <Log
          loading={loading}
          dataSource={dataSource}
          total_elements={total_elements}
          params={params}
          onChangeParam={onChangeParam}
          onClickRenew={_handleGetLogs}
          directions={direction}
          openTypes={open_type}
        />
      </Col>
    </Row>
  );
}

export default React.memo(BarrierLogPage);
